// extracted by mini-css-extract-plugin
export var formContainer = "_kr-0";
export var message = "_kr-1";